module.exports = __webpack_public_path__ + "media/images/sme-bg-mobile-c4decbeba452d293760dbf26dfe9a8ec.jpg";